import isElementVisibleInViewport from 'components/Dashboard/utils/isElementVisibleInViewport'

export default function scrollToButtonElement(
  buttonElement: HTMLButtonElement | null,
  shouldScroll: boolean,
  inline?: ScrollLogicalPosition,
): void {
  if (!buttonElement) {
    return
  }

  if (shouldScroll && !isElementVisibleInViewport(buttonElement)) {
    buttonElement?.scrollIntoView({
      inline: inline || 'start',
    })
  }
}
